import React, { useRef } from 'react';
import { Tooltip } from 'shared/components/ui/tooltip';
import { tooltipDelay } from 'shared/constants';

import * as Styled from './event.style';
import { EventCard } from './event-card';
import { useTimeBasedStyle } from './use-time-based-style';

export type ExternalEventProps = {
  name: string;
  url?: string;
  color?: string;
  startDate?: string;
  endDate?: string;
  timeText?: string;
  isPast?: boolean;
};

export const ExternalEvent: React.FC<ExternalEventProps> = ({
  name,
  url,
  color,
  startDate,
  endDate,
  timeText,
  isPast,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { numberOfLines } = useTimeBasedStyle(startDate, endDate);

  const _onClick = url
    ? () => window.open(url, '_blank', 'noreferrer')
    : undefined;

  return (
    <>
      <EventCard
        ref={containerRef}
        title={name}
        color={color}
        timeText={timeText}
        isPast={isPast}
        numberOfLines={numberOfLines}
        onClick={_onClick}
        leading={<Styled.ColorBarSlot $color={color} $past={isPast} />}
      />
      <Tooltip
        referenceElement={containerRef}
        label={name}
        delay={tooltipDelay}
      />
    </>
  );
};
